import * as Immutable from "immutable";
import VisualizationConfig from "views/logic/aggregationbuilder/visualizations/VisualizationConfig";
import { COLORSCALES } from "views/logic/aggregationbuilder/visualizations/HeatmapVisualizationConfig";
export { COLORSCALES };
export default class NetworkVisualizationConfig extends VisualizationConfig {
  constructor(colorScale, reverseScale) {
    super();
    this._value = { colorScale, reverseScale };
  }
  get colorScale() {
    return this._value.colorScale;
  }
  get reverseScale() {
    return this._value.reverseScale;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(colorScale, reverseScale) {
    return new NetworkVisualizationConfig(colorScale, reverseScale);
  }
  static empty() {
    return new NetworkVisualizationConfig("YlOrRd", false);
  }
  toJSON() {
    const { colorScale: color_scale, reverseScale: reverse_scale } = this._value;
    return { color_scale, reverse_scale };
  }
  static fromJSON(_type, value = { color_scale: "YlOrRd", reverse_scale: false }) {
    const { color_scale: colorScale, reverse_scale: reverseScale } = value;
    return NetworkVisualizationConfig.create(colorScale, reverseScale);
  }
}
export class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  colorScale(value) {
    return new Builder(this.value.set("colorScale", value));
  }
  reverseScale(value) {
    return new Builder(this.value.set("reverseScale", value));
  }
  build() {
    const { colorScale, reverseScale } = this.value.toObject();
    return new NetworkVisualizationConfig(colorScale, reverseScale);
  }
}
